import { render, staticRenderFns } from "./ConsumableCard.vue?vue&type=template&id=4398d96a&scoped=true&"
import script from "./ConsumableCard.vue?vue&type=script&lang=ts&"
export * from "./ConsumableCard.vue?vue&type=script&lang=ts&"
import style0 from "./ConsumableCard.vue?vue&type=style&index=0&id=4398d96a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4398d96a",
  null
  
)

export default component.exports